import React from 'react';
import { POST_TEXT } from '../../consts';
import { PostFooterProps } from '../../types';
import {
  ButtonWrapper,
  CancelButton,
  Container,
  DeleteButton,
  DeleteContainer,
  Menu,
  MenuContainer,
  SaveButton,
  Wrapper,
} from './styles';
import { ViewsAndVisits } from './ViewsAndVisits';

export const Footer: React.FC<PostFooterProps> = (props) => {
  const {
    canDelete = true,
    canEdit = true,
    clickCount,
    isEditMode,
    isDeleteMode,
    numLikes,
    onClickCancel,
    onClickDelete,
    onClickDeleteMenu,
    onClickEditMenu,
    onClickSave,
    showMenu,
    showLikes,
    showViews,
    showVisits,
    viewCount,
  } = props;
  const showViewsAndVisits = showLikes ?? showViews ?? showVisits;
  const viewsAndVisitsProps = {
    clickCount,
    numLikes,
    showLikes,
    showViews,
    showVisits,
    viewCount,
  };

  return (
    <>
      {isDeleteMode && (
        <DeleteContainer>
          {POST_TEXT.FOOTER.DELETE_TEXT}
          <ButtonWrapper>
            <CancelButton onClick={onClickCancel} />
            <DeleteButton onClick={onClickDelete} />
          </ButtonWrapper>
        </DeleteContainer>
      )}
      <Container isDeleteMode={isDeleteMode}>
        {isEditMode && (
          <ButtonWrapper>
            <CancelButton onClick={onClickCancel} />
            <SaveButton onClick={onClickSave} />
          </ButtonWrapper>
        )}
        {!isDeleteMode && !isEditMode && (
          <Wrapper>
            {showViewsAndVisits && <ViewsAndVisits {...viewsAndVisitsProps} />}
            {showMenu && (canDelete || canEdit) && (
              <MenuContainer>
                <Menu
                  items={[
                    ...(canEdit ? [{ label: POST_TEXT.FOOTER.MENU.EDIT, onClick: onClickEditMenu }] : []),
                    ...(canDelete
                      ? [{ label: POST_TEXT.FOOTER.MENU.DELETE, isError: true, onClick: onClickDeleteMenu }]
                      : []),
                  ]}
                />
              </MenuContainer>
            )}
          </Wrapper>
        )}
      </Container>
    </>
  );
};
